/*
 * Copyright (c) 2023 NEXTwfl INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTwfl INTL SRL.
 * Use is subject to license and non-disclosure terms
 */
import {JSONable} from "@irian-ro/abstract-resource";
import {ValidIntervalModel} from "./valid-interval.model";
import {WorkflowStepConfigVoModel} from "./workflow-step-config-vo.model";

export class WorkflowStepVoModel extends JSONable {
  uuid: string | null = null;
  name: string | null = null;
  defaultLabel: string | null = null;
  systemName: string | null = null;
  orderInWorkflow: string | null = null;
  validInterval?: ValidIntervalModel | null = null;
  workflowStepConfigVo: WorkflowStepConfigVoModel | null = null;

}
